import api from "~/store/api"
import serialize from "~/store/serialize"

export const listAppUsers = (data) => {
  return api.post("/app/users", data).then((res) => {
    return res.data
  })
}

export const getWailist = () => {
  return api
    .get("/waitlist")
    .then((res) => serialize("waitlist", res.data.data))
}

export const listAdmins = () => {
  return api.get("/users").then((res) => serialize("admin", res.data.data))
}

export const publishedCoursesCount = () => {
  return api.get("/courses/has_been_published").then((res) => res.data.count)
}
export const maxTakenCourseCount = () => {
  return api.get("/courses/max_taken_courses").then((res) => res.data.count)
}

export const createAdmin = (data) => {
  return api.post("/users/invite", data).then((res) => res.data)
}

export const deleteAdmin = (id) => {
  return api.delete(`/users/${id}`).then((res) => res.data)
}

export const setPermissions = (data) => {
  return api.post("/users/permissions", data).then((res) => res.data)
}

export const getMe = () => {
  return api.get("/users/me").then((res) => res.data.data)
}

export const updateMe = (data) => {
  return api.put("/users/me", data).then((res) => {
    return res.data
  })
}

export const updatePassword = (data) => {
  return api.put("/users/me/password", data).then((res) => res.data)
}

export const magicAuth = (data) => {
  return api.post("/users/auth/magic", data).then((res) => {
    api.defaults.headers.common["Authorization"] = res.data.token
    return res.data
  })
}

export const forgotPassword = (data) => {
  return api.post("/users/forgot", data).then((res) => {
    api.defaults.headers.common["Authorization"] = res.data.token
    return res.data
  })
}

export const otpRequest = (data) => {
  return api.post("/users/otp-request", data).then((res) => {
    return res.data
  })
}

export const otpVerify = (data) => {
  return api.post("/users/otp-verify", data).then((res) => {
    api.defaults.headers.common["Authorization"] = res.data.token
    return res.data
  })
}

export const resetPassword = (data) => {
  return api.post("/users/reset/magic", data).then((res) => res.data)
}

export const getUsersCourseDetails = (id) => {
  return api.get(`/users/courses/${id}`).then((res) => res.data)
}

export const listUserInvites = (id) => {
  return api.get(`/users/invites/${id}`).then((res) => res.data)
}
export const listAnalyticsUsers = () => {
  return api.get(`/analytics_users`).then((res) => res.data.data)
}

export const createAnalyticsUser = (data) => {
  return api.post(`/analytics_users`, data).then((res) => res.data.data)
}
export const getDemoUsers = (data) => {
  return api.post("users/get_demo_users", data).then((res) => res.data.data)
}

export const getDemoToken = (userId) => {
  return api
    .post("users/demoToken", { insertId: userId })
    .then((res) => res.data.data)
}

export const updateAnalyticsUser = (moreData) => {
  const { id, ...data } = moreData
  return api.put(`/analytics_users/${id}`, data).then((res) => res.data.data)
}

export const deleteAnalyticsUser = (id) => {
  return api.delete(`/analytics_users/${id}`).then((res) => res.data.data)
}

export const createAppUser = (data) => {
  return api.post(`app/users/create`, data).then((res) => res.data)
}

export const updateAppUser = ([id, data]) => {
  return api.put(`app/users/${id}`, data).then((res) => res.data)
}

export const listAppTestUsers = ({ queryKey }) => {
  const [_, { course_id }] = queryKey
  return api
    .get(`app/test_users?course_id=${course_id}`)
    .then((res) => res.data)
}

export const updateAppCourseTestUsers = (data) => {
  return api.post(`app/assign_test_users`, data).then((res) => res.data)
}

export const createAppDemoUser = (data) =>
  api.post("/users/demo", data).then((res) => res.data)
